import React, { FC, useState } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";

import Breadcrumbs from "../../shared/base-components/Breadcrumbs";
import ExpenseCategoryList from "./ExpenseCategoryList";
import ExpenseList from "./ExpenseList";
import ExpenseDetailList from "./ExpenseDetailList";

const ExpensePage: FC = () => {
  document.title = "Giderler | Bu ekranda giderleri görüntülyebilirsiniz.";
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const [step, setStep] = useState<{
    step: number;
    id: string;
    lastId: string;
    name: string;
  }>({
    step: 0,
    id: "",
    lastId: "",
    name: "",
  });

  return (
    <React.Fragment>
      <div className={isMobile ? "page-content-mobile" : "page-content"}>
        <Container fluid>
          {step.step > 0 ? (
            <button
              type="button"
              title="Previous month"
              aria-pressed="false"
              className="fc-prev-button btn btn-light-primary p-3"
              onClick={() =>
                step.step > 0 &&
                setStep((prevState) => {
                  return { ...prevState, step: prevState.step - 1 };
                })
              }
            >
              <span className="fa fa-chevron-left"></span> Geri
            </button>
          ) : (
            <Breadcrumbs title="Giderler" breadcrumbItem="Giderler Listesi" />
          )}

          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  {step.step === 0 && <ExpenseCategoryList setStep={setStep} />}

                  {step.step === 1 && (
                    <ExpenseList
                      pageName={step.name}
                      id={step.id}
                      setStep={setStep}
                      lastId={step.lastId}
                    />
                  )}

                  {step.step === 2 && (
                    <ExpenseDetailList id={step.id} setStep={setStep} />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ExpensePage;
